export const FACEBOOK_URL = 'https://www.facebook.com/nacavernadamarta/';
export const INSTAGRAM_URL = 'https://www.instagram.com/nacavernadamarta/';
